<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <router-view name="header" /> -->
    <navBar />
    <div class="">
      <router-view/>
    </div>
    <footerGlobal />
    <!-- <router-view name="footer" /> -->
  </div>
</template>

<script>
import navBar from '@/components/navBar'
import footerGlobal from '@/components/footer'
export default {
  name: 'App',
  components: {
    navBar,
    footerGlobal
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  /* font-family: "Dosis", sans-serif, "Microsoft YaHei", 微软雅黑; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 80px;
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue